import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

import type { StepComponentProps } from 'components/Stepper';

import useStyles from './VerifyingAccount.style';

type VerifyingAccountProps = StepComponentProps;

const VerifyingAccount: React.FC<VerifyingAccountProps> = ({ pending }) => {
  const theme = useTheme();
  const { container, headerText } = useStyles();
  const circularProgressSize = theme.typography.h2.fontSize;
  return pending ? (
    <div className={container}>
      <CircularProgress
        size={circularProgressSize}
        title="loading spinner"
        aria-hidden
      />
      <Typography variant="h2" className={headerText}>
        We&apos;re verifying your account...
      </Typography>
    </div>
  ) : (
    <Typography variant="h2">
      {
        "We're having trouble verifying your account.\nPlease try clicking the link in the verification email again or generate a new verification email."
      }
    </Typography>
  );
};

export default VerifyingAccount;
